import { CreateAncestorsLineageForSidePanel } from "@src/cloud-connect/node-manager/entities/create-ancestors-lineage-for-side-panel";
import { formatPathFromSegments } from "@src/cloud-connect/utils/format-path-from-segments";
import { preconfiguredColors } from "../../components/organisms/dashboard-panel/graph-color-palette";
import store from "@src/reducers/store";
import { formatChartTooltipDate } from "@src/cloud-connect/utils/timezone-display-utils";
import {
  buildTooltipDateHeader,
  buildTooltipSeriesRow,
} from "@src/cloud-connect/charts/chart-tooltip-utils";

export const buildAncestorBreadCrumbs = (nodeId: string): string => {
  return formatPathFromSegments(
    new CreateAncestorsLineageForSidePanel().createMachineStructureAncestorsLineageForSidePanel(
      nodeId,
    ),
    { trimStart: true, trimEnd: true },
  );
};

export const tooltipFormatter = (params: any) => {
  const timezone = store.getState().yourSlice.timezone;
  const language = store.getState().yourSlice.language;
  const formattedDate = formatChartTooltipDate(
    params[0].axisValue,
    timezone,
    language,
  );

  let tooltipHTML = buildTooltipDateHeader(formattedDate);

  params.forEach((item: any, index: number) => {
    const location = item.data?.location;
    const value = item.data?.value ?? item.value;
    const cleanName = item.seriesName.replace(/\s\(\d+\)/, "");
    tooltipHTML += buildTooltipSeriesRow({
      marker: item.marker,
      color: preconfiguredColors[index % preconfiguredColors.length],
      name: cleanName,
      value,
      location,
    });
  });

  return tooltipHTML;
};

export const tooltipValueOnlyFormatter = (params: any) => {
  const timezone = store.getState().yourSlice.timezone;
  const language = store.getState().yourSlice.language;
  const formattedDate = formatChartTooltipDate(
    params[0].axisValue,
    timezone,
    language,
  );

  let tooltipHTML = buildTooltipDateHeader(formattedDate);

  params.forEach((item: any) => {
    const value = item.data?.value ?? item.value;
    tooltipHTML += `<span style="display: flex; gap: 5px; align-items: center;">${item.marker}<span style="color: white; font-weight: 800;">${value}</span></span>`;
  });

  return tooltipHTML;
};

export const legendFormatter = (name: string): string => {
  return name.replace(/\s\(\d+\)/, "");
};
